var map = {
	"./comodo-secure.png": 1095,
	"./flag-france.png": 1096,
	"./flag-germany.png": 1097,
	"./flag-italy.png": 1098,
	"./flag-netherlands.png": 1099,
	"./flag-portugal.png": 1100,
	"./flag-spain.png": 1101,
	"./flag-usa.png": 1102,
	"./global-cart-seal.png": 1103,
	"./icon-wanelo copy.png": 1104,
	"./icon-wanelo.png": 1105,
	"./icon-whatsapp copy.png": 1106,
	"./icon-whatsapp.png": 1107,
	"./lock.png": 1108,
	"./pagamento-cinza.png": 1109,
	"./pagamento-verde.png": 1110,
	"./pagamento-vermelho.png": 1111,
	"./payment-methods-br.png": 1112,
	"./payment-methods-global.png": 1113,
	"./payment-methods.png": 1114,
	"./pedido-cinza.png": 1115,
	"./pedido-verde.png": 1116,
	"./pedido-vermelho.png": 1117,
	"./selo-ebit-ouro.png": 1118,
	"./selo-eureciclo.png": 1119,
	"./selo-internet-segura.png": 1120,
	"./selo-ra1000.png": 1121,
	"./selo_100-seguro-retina.png": 262,
	"./selo_100-seguro.png": 1122,
	"./selo_site_seguro_certisign.png": 1123,
	"./selo_site_seguro_mcafee.png": 1124,
	"./selo_site_seguro_norton.png": 1125,
	"./selo_site_seguro_norton_small.png": 1126,
	"./separacao-cinza.png": 1127,
	"./separacao-verde.png": 1128,
	"./separacao-vermelho.png": 1129,
	"./shipping-methods-global.png": 1130,
	"./transporte-cinza.png": 1131,
	"./transporte-verde.png": 1132,
	"./transporte-vermelho.png": 1133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1094;